import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {useRedirectMessage} from "../../../utils/redirectMessage";
import {makeApiCall, makeApiCallPost} from "../../../Api/makeApiCall";
import Page from "../../Components/Page";
import {LoadingWrapper} from "../../Components/LoadingWrapper";
import {toastError, toastSuccess} from "../../../utils/toast";
import {SELECT_COLUMN} from "../../Components/ReactTable/CheckboxColumnComponent";
import IconImage, {Icons} from "../../Components/IconImage";
import ConfirmationModal from "../../Components/ConfirmationModal";
import {toast} from "react-toastify";
import {Breadcrumbs} from "../../Components/Breadcrumbs";
import ReactTable from "../../Components/ReactTable";
import NameValueLabels from "../../Components/NameValueLabels";
import DeleteButton from "../../../utils/components/DeleteButton";
import Files from "react-files";
import NumberedTextAreaList from "../../Components/NumberedTextAreaList";
import BulkAssignStoresModal from "../../Components/BulkAssignStoresModal";
import {RETAILER_ID_NAME_COLUMN} from "../../Components/ReactTable/common_custom_columns";


const MarketsToStores = () => {
    const params = useParams()
    const marketId = parseInt(params.marketId)

    useRedirectMessage();

    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/marketsToStores/?market_id=${marketId}`;

    const [marketsToStores, setMarketToStores] = useState([]);
    const [loading, setLoading] = useState(false);
    const [unassignStoresModalVisible, setUnassignStoresModalVisible] = useState(false);
    const [marketDescription, setMarketDescription] = useState(undefined);
    const [bulkUploadSelectedFile, setBulkUploadSelectedFile] = useState(undefined);
    const [bulkUploadFileSelectionModalVisible, setBulkUploadFileSelectionModalVisible] = useState(false);
    const [bulkUploadIssues, setBulkUploadIssues] = useState(undefined);

    const storesCountText = (stores) => `${stores.length} ${stores.length === 1 ? "store" : "stores"}`
    const storesSkippedText = (stores) => stores.length === 1 ? "was skipped" : "were skipped"

    const loadMarketToStores = () => {
        setLoading(true);
        Promise.all([
            makeApiCall(endpointUrl),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/marketsTwo/`)
        ])
            .then(([
                       marketsToStoresService,
                       marketsServiceTwo,
                   ]) => {


                setMarketToStores(marketsToStoresService.data);
                const marketDescriptionFiltered = marketsServiceTwo.data.filter(market => market.marketId === marketId);
                setMarketDescription(marketDescriptionFiltered.length > 0 ? marketDescriptionFiltered[0].description : undefined);

            })
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadMarketToStores()
    }, []);

    const saveUnassignStoresAndRefresh = (selectedRows) => {
        setLoading(true)
        setUnassignStoresModalVisible(false)
        return makeApiCallPost(
            `${process.env.REACT_APP_EDP_API_BASE_URL}/marketsToStores/unassignStores`,
            {
                marketId: marketId,
                storeIds: selectedRows.map(row => row.original.storeId),
            }
        ).then((response) => {
            if (response?.apiError) {
                console.error(`error =============> ${JSON.stringify(response.apiError)}`);
                toastError(toast, `Issue unassigning stores`)
                setLoading(false);
            }
        }).then(() => loadMarketToStores())
    }

    return (<Page beta name={"Market To Stores"}
                  breadCrumbs={<Breadcrumbs items={[{label: "Services"},
                      {label: "Ops Market Service", to: "/marketServiceTwo"},
                      {label: `${marketId}`}]}
                  />}
    >
        <LoadingWrapper loading={loading}>
            <NameValueLabels labelValuePairs={[
                {label: "Market:", value: `${marketDescription} (${marketId})`}
            ]}/>
            <ReactTable
                filterable
                autoResetSelectedRows={false}
                getRowId={row => row.storeId}
                data={marketsToStores}
                columns={[
                    SELECT_COLUMN,
                    {header: "Market Id", accessorKey: "marketId"},
                    RETAILER_ID_NAME_COLUMN,
                    {header: "Store Id", accessorKey: "storeId"},
                    {header: "Store Name", accessorKey: "store_name"},
                ]
                }
                initialState={{pagination: {pageSize: 10}}}
            >
                {
                    ({table}) => {
                        const selectedRows = table.getSelectedRowModel().rows;
                        return (
                            <span className={'designation-action-buttons-container'}
                                  data-testid={"stores-action-button-container"}>
                                 <a type={"button"} className={"button primary"}
                                    href={`/marketsToStores/assignStore/${marketId}`}>Assign Store</a>
                                 <div className="designation-header-component-divider"/>
                                 <button type={'button'} aria-label={'upload'} onClick={() => {
                                    setBulkUploadSelectedFile(undefined)
                                    setBulkUploadFileSelectionModalVisible(true)
                                    }} className={"designation-action-button"} disabled={false}>
                                     <IconImage iconType={Icons.BATCH_ASSIGN_FROM_FILE_IMPORT}/>
                                 </button>
                                 <button type={'button'} aria-label={'un-assign'}
                                         onClick={() => setUnassignStoresModalVisible(true)}
                                         className={"designation-action-button"}
                                         disabled={!selectedRows?.length}>
                                     <IconImage iconType={Icons.UN_ASSIGN}/>
                                 </button>
                                {unassignStoresModalVisible && <ConfirmationModal
                                    confirmButtonClass={"danger-button"}
                                    confirmButtonText={"Unassign"}
                                    headerText={`Unassign ${selectedRows.length === 1 ? 'Store' : 'Stores'}`}
                                    cancellationCallback={() => setUnassignStoresModalVisible(false)}
                                    confirmationCallback={() => saveUnassignStoresAndRefresh(selectedRows)}>
                                    {`Unassign ${selectedRows.length} ${selectedRows.length === 1 ? 'store' : 'stores'} from`}&nbsp;
                                    <b>{`${marketId}`}</b>
                                </ConfirmationModal>}
                            </span>
                        )
                    }
                }
            </ReactTable>
            <BulkAssignStoresModal isOpen={bulkUploadFileSelectionModalVisible} onClose={() => setBulkUploadFileSelectionModalVisible(false)}>
                <div>Prepare a list of store ids to assign to <b>{`${marketId} - ${marketDescription}`}</b>.</div>
                <div>File should be in .csv format.</div>
                <div>File contain ONLY store ids, comma-separated and/or on multiple lines.</div>
                <div>
                    {!bulkUploadSelectedFile && <Files
                        className={"button"}
                        onChange={(files) => {
                            setBulkUploadSelectedFile((files[0]))
                        }}

                        accepts={['.csv']}
                        multiple={false}
                        maxFileSize={10*1024*1024}
                        clickable
                    >
                        Browse...
                    </Files>}
                    {bulkUploadSelectedFile && <div>
                        <div className={'selected-file-box'}>
                            <IconImage iconType={Icons.FILE_UPLOAD}/>
                            <div>{bulkUploadSelectedFile.name}</div>
                            <DeleteButton onDelete={() => setBulkUploadSelectedFile(undefined)}/>
                        </div>
                        <div className={'bottom-button-row'}>
                            <button type={'button'} className={"cancel"} aria-label={'cancel'} onClick={() => setBulkUploadFileSelectionModalVisible(false)}>
                                Cancel
                            </button>
                            <button type={'button'} className={'primary'} onClick={() => {
                                const fileReader = new FileReader();

                                fileReader.onloadend = (e) => {
                                    const content = e.target.result;
                                    const data = {storeIds: content, marketId: marketId};
                                    setLoading(true)
                                    setBulkUploadFileSelectionModalVisible(false)
                                    makeApiCallPost(`${process.env.REACT_APP_EDP_API_BASE_URL}/marketsToStores/bulkAssign`, data)
                                        .then(async (response) => {
                                            await loadMarketToStores();
                                            if (response.newAssigns?.length && !response.duplicates?.length && !response.invalids?.length) {
                                                toastSuccess(toast, `Successfully batch assigned ${storesCountText(response.newAssigns)} to ${marketId} - ${marketDescription}`)
                                            } else {
                                                setBulkUploadIssues(response)
                                            }
                                        });
                                }
                                fileReader.readAsText(bulkUploadSelectedFile)
                            }}>
                                Import and Assign
                            </button>
                        </div>
                    </div>
                    }
                </div>
            </BulkAssignStoresModal>
            <BulkAssignStoresModal isOpen={bulkUploadIssues !== undefined} onClose={() => setBulkUploadIssues(undefined)}>
                {bulkUploadIssues?.apiError ? <>
                    <div>That didn’t work. The system encountered an unexpected format in the file.</div>
                    <div>Check your CSV file and try uploading again.</div>
                </> : <>
                    {bulkUploadIssues?.newAssigns?.length ? <>
                        <div>{storesCountText(bulkUploadIssues.newAssigns)} successfully imported and assigned to <b>{marketId} - {marketDescription}</b>.</div>
                    </> : <></>}
                    {bulkUploadIssues?.duplicates?.length ? <>
                        <div>{storesCountText(bulkUploadIssues.duplicates)} found already on the list {storesSkippedText(bulkUploadIssues.duplicates)}.</div>
                        <NumberedTextAreaList values={bulkUploadIssues.duplicates}/>
                    </> : <></>}
                    {bulkUploadIssues?.invalids?.length ? <>
                        <div>{storesCountText(bulkUploadIssues.invalids)} not found in the Store Service {storesSkippedText(bulkUploadIssues.invalids)}.</div>
                        <NumberedTextAreaList values={bulkUploadIssues.invalids}/>
                    </> : <></>}
                </>}
                <div className={'bottom-button-row'}>
                    <button type={'button'} className={'close'} onClick={() => setBulkUploadIssues(undefined)}>Close</button>
                </div>
            </BulkAssignStoresModal>
        </LoadingWrapper>
    </Page>);
};

export default MarketsToStores;